import { Action, State, StateContext, Store } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { NgxsStateFacade } from '../../shared/store/ngxs-state-facade';
import { PaymentService } from '../services/payment.service';

export interface CustomAmountPaymentStateModel {
  customAmountForm: {
    model: {
      amount: number;
    };
    dirty: boolean;
    status: string;
    errors: { [key: string]: unknown };
  };
}

export class StartCustomPayment {
  static readonly type = '[CustomAmountPayment] Start Custom Payment';
}

export class Reset {
  static readonly type = '[CustomAmountPayment] Reset';
}

const defaults: CustomAmountPaymentStateModel = {
  customAmountForm: {
    model: {
      amount: 0,
    },
    dirty: false,
    status: '',
    errors: {},
  },
};

@State<CustomAmountPaymentStateModel>({
  name: 'customAmount',
  defaults: defaults,
})
@Injectable()
export class CustomAmountPaymentState extends NgxsStateFacade<CustomAmountPaymentStateModel> {
  constructor(
    store: Store,
    private readonly paymentSvc: PaymentService,
  ) {
    super(store, 'customAmount');
  }

  startCustomPayment(): void {
    this.store.dispatch(new StartCustomPayment());
  }

  reset(): void {
    this.store.dispatch(new Reset());
  }

  // --- Actions ---

  @Action(StartCustomPayment)
  startCustomPaymentHandler(ctx: StateContext<CustomAmountPaymentStateModel>) {
    this.paymentSvc.addPayment(ctx.getState().customAmountForm.model.amount);
  }

  @Action(Reset)
  resetHandler(ctx: StateContext<CustomAmountPaymentStateModel>) {
    ctx.setState(defaults);
  }
}
